const crypto = require("crypto");

export function getPreviewToken(data) {
  return fetch("/next-api/jwt/sign", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => res.json());
}
export function getJwt(data = {}, expiresIn = "1h") {
  console.log("jwt data", data);
  return fetch("/next-api/jwt/sign", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => res.json());
}
export async function verifyJwt(token) {
  const res = await fetch("/next-api/jwt/verify", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  if (!res.ok) throw await res.json();

  return await res.json();
}

export const cleanObject = (obj) => {
  return Object.entries(obj).reduce((o, [name, value]) => {
    value = Number(value) || undefined;
    if (value !== undefined && value !== null) {
      o[name] = value;
    }
    return o;
  }, {});
};

// export function generatePayfortSignature(data, PAYFORT_REQ_SHA) {
//   // function for calculating signature
//   const REMOVED_PARAMS_SIGN = [
//     "card_security_code",
//     "card_number",
//     "expiry_date",
//     "card_holder_name",
//     "remember_me",
//     "eci",
//     "signature",
//   ];
//   const filtered = Object.entries(data).filter(
//     ([name]) => !REMOVED_PARAMS_SIGN.includes(name),
//   );
//   const concattedNoSHA = filtered
//     .sort((a, b) => (a[0] < b[0] ? -1 : 1))
//     .map((item) => item.join("="))
//     .join("");
//   return sha256(PAYFORT_REQ_SHA + concattedNoSHA + PAYFORT_REQ_SHA);
// }

export function encrypt(text) {
  const cipher = crypto.createCipher("aes-256-cbc", "d6F3Efeq");
  let crypted = cipher.update(text, "utf8", "hex");
  crypted += cipher.final("hex");
  return crypted;
}
